export default __webpack_public_path__ + "static/media/dropzoneimage.39a1fb90.svg";